.report-download,
.recommendations-section {
  display: grid;
  grid-gap: 1.67em 3em;
  align-items: center;
  background-color: #F5F5F5;
  color: #08090D;
  border-top: 1px solid #D7D7D7;
}
@media (min-width: 813px) {
  .report-download,
  .recommendations-section {
    padding: 35px;
    text-align: left;
    grid-template-areas: "thumbnail title" "thumbnail middleArea" "thumbnail cta" "thumbnail numusers";
    grid-template-columns: 1fr 2fr;
  }
  .report-download .report_image,
  .recommendations-section .report_image,
  .report-download .report-fan-image,
  .recommendations-section .report-fan-image {
    justify-self: flex-end;
  }
}
@media (max-width: 812px) {
  .report-download,
  .recommendations-section {
    background: #F5F5F5;
    line-height: 1.2;
    padding: 20px;
    grid-template-areas: "thumbnail" "title" "middleArea" "cta" "numusers";
    grid-template-columns: auto;
    justify-content: center;
    text-align: center;
  }
  .report-download .report_image,
  .recommendations-section .report_image,
  .report-download .report-fan-image,
  .recommendations-section .report-fan-image {
    justify-self: center;
  }
}
.report-download .report_image,
.recommendations-section .report_image,
.report-download .report-fan-image,
.recommendations-section .report-fan-image {
  grid-area: thumbnail;
}
.report-download .title,
.recommendations-section .title {
  grid-area: title;
  font-size: 24px;
  font-weight: 900;
  line-height: 1.3;
  font-family: 'Lato', sans-serif;
}
.report-download .title > a:hover,
.recommendations-section .title > a:hover {
  background-color: inherit;
}
.report-download .middle,
.recommendations-section .middle {
  grid-area: middleArea;
  font-size: 16px;
  font-family: 'Lato';
}
.report-download .cta,
.recommendations-section .cta {
  grid-area: cta;
}
.report-download .numusers,
.recommendations-section .numusers {
  grid-area: numusers;
  font-size: 14px;
  font-family: 'Lato';
}
.report_image {
  font-family: 'Lato', sans-serif;
  background: url(../../images/reports/thumbnail_bg.png) no-repeat;
  background-size: cover;
  background-color: transparent;
  box-shadow: 12px 12px 25px 0 rgba(50, 50, 50, 0.3);
  margin: 0 auto;
  position: relative;
  max-width: 211px;
  width: 100%;
  padding-top: min(139%, 294px);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.report_image .report-inner-wrapper {
  position: absolute;
  text-decoration: none;
  text-align: left;
  padding: 65px 20px 5px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.report_image .report-cover-txt {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.report_image img.generic {
  margin: -20px;
}
.report_image:hover {
  text-decoration: none;
  background-color: transparent !important;
}
.report_image .report-subtext {
  color: #A9A9A9;
  font-size: 15px;
}
.report_image .report-title {
  color: #08090D;
  font-size: 1.3rem;
  line-height: 1.2;
  font-weight: 600;
}
.report_image .report-title-md {
  font-size: 1rem;
  line-height: 1.4;
}
.report_image .report-title-sm {
  font-size: 0.8rem;
  line-height: 1.4;
  margin: 3px 0;
}
.report_image .ps-logo {
  text-align: center;
  margin-top: 10px;
}
.report_image:after {
  content: 'PDF';
  position: absolute;
  top: 15px;
  right: -5px;
  width: 40px;
  height: 20px;
  line-height: 1;
  font-weight: 600;
  font-size: 1.3rem;
  background-color: red;
  color: white;
  padding: 5px;
}
.recommendations-section .report-fan-image {
  width: 310px;
}
.posting6 .user-info {
  overflow: hidden;
  font-size: 14px;
}
.posting6 .username,
.posting6 .user-info {
  font-family: 'Lato', sans-serif;
}
.posting6 .username {
  color: #08090D;
}
.comparison-block {
  display: flex;
}
.comparison-block:not(.overview-row).multi > * {
  width: 327px;
  min-width: 327px;
  box-sizing: border-box;
}
.comparison-block > * {
  flex-grow: 1;
  flex-basis: 0;
  padding: 35px;
  min-width: 0;
  /* necessary for long text with ellipsis which stretches the column */
}
.comparison-block > *:not(:last-child) {
  border-right: 1px solid #E5E6E1;
}
.comparison-block .expander {
  line-height: 1.7;
  /* max-height = line-height (1.5) * # of lines - set var "show-lines" as element inline style */
  max-height: calc(var(--show-lines) * 1.7em);
}
.comparison-block .line1 {
  color: #8d8c86;
  font-size: 14px;
  font-family: 'Lato', sans-serif;
}
.label-row1 {
  text-align: left;
  font-weight: 900;
  padding: 10px 0;
  color: #08090D;
  font-size: 20px;
  border-bottom: 1px solid #08090D;
  margin-top: 50px;
}
.label-row1 .label-text,
.label-row1 span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 900;
}
.label-row1 .label-text .image-container,
.label-row1 span .image-container {
  height: 22px;
}
ul {
  padding: 0;
}
#comparison-page-container {
  width: 980px;
  margin: auto;
  position: relative;
}
#comparison-page-header {
  text-align: center;
  padding: 24px 10px 30px;
  background: white;
  width: 960px;
  z-index: 100;
}
#comparison-page-header .comparison-name {
  width: 660px;
  margin-right: auto;
  margin-left: auto;
  font-size: 30px;
}
#comparison-page-header .promo-video-link {
  font-weight: bold;
}
.product-name-and-rating {
  text-align: center;
  padding: 30px 0;
}
.product-name-and-rating .logo-line {
  margin-bottom: 2em;
}
.product-name-and-rating .logo-line img {
  padding: 10px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
}
.product-name-and-rating .splitter {
  margin-left: 7px;
  margin-right: 7px;
}
.product-name-and-rating > * + * {
  margin-top: 0.5em;
}
.product-name-line {
  line-height: 1.2em;
  font-size: 26px;
  font-weight: bold;
  font-family: 'Lato', sans-serif;
  text-align: center;
}
.product-name-line a {
  color: inherit;
}
#snippets-section .product-column .prevClass,
#snippets-section .product-column .nextClass {
  position: absolute;
  top: auto;
  bottom: 25px;
  font-family: 'Lato', sans-serif;
}
#snippets-section .product-column .prevClass a,
#snippets-section .product-column .nextClass a {
  font-weight: bold;
  color: #08090D;
}
#snippets-section .product-column .prevClass {
  left: 15px;
}
#snippets-section .product-column .nextClass {
  right: 15px;
}
#snippets-section .product-column .title-box {
  background: unset;
  padding: 15px 0;
  font-family: 'Lato', sans-serif;
  color: #08090D;
}
.line1 {
  color: #8d8c86;
  font-size: 14px;
  font-family: 'Lato', sans-serif;
}
#popular-solutions .line1 {
  color: #8d8c86;
}
.ui-widget-overlay {
  background: black;
  opacity: 0.65;
}
ul#controls {
  margin: 0;
}
.comparison-slider:not(.graphic-area),
.comparison-slider:not(.graphic-area) li {
  height: 180px;
  overflow: hidden;
}
